/* eslint-disable sort-keys-fix/sort-keys-fix */
import { type DefaultGenerics, Navigate, type Route } from "@tanstack/react-location"
import { lazy } from "react"
import { CdnList } from "@/pages/ContentSteering/Cdn/CdnList"
import { SegmentationPage } from "@/pages/ContentSteering/Segmentation"
import { Settings } from "@/pages/ContentSteering/Settings"

// Misc
const SwitchApp = lazy(() =>
  import("@/pages/SwitchApp").then(module => ({ default: module.SwitchApp }))
)
const Main = lazy(() => import("@/pages/Main").then(module => ({ default: module.Main })))

const AppEventLog = lazy(() =>
  import("@/pages/ContentSteering/AppEventLog").then(module => ({ default: module.AppEventLog }))
)

const Workspace = lazy(() =>
  import("@/pages/ContentSteering/Workspace").then(module => ({ default: module.Workspace }))
)

const SegmentEditionPage = lazy(() =>
  import("@/pages/ContentSteering/Segmentation/SegmentEdition/SegmentEditionPage").then(module => ({
    default: module.SegmentEditionPage
  }))
)

const CdnEditionPage = lazy(() =>
  import("@/pages/ContentSteering/Cdn/CdnEdition/CdnEditionPage/").then(module => ({
    default: module.CdnEditionPage
  }))
)

const NotFound = lazy(() =>
  import("@quortex/front-common").then(module => ({ default: module.NotFound }))
)

export const switchRoutes: Route<DefaultGenerics>[] = [
  {
    path: "switch",
    element: <SwitchApp />,
    children: [
      {
        path: "workspaces",
        element: <Main />,
        children: [
          {
            path: ":workspaceUuid/segmentation/segment/:segmentUuid",
            element: <SegmentEditionPage />
          },
          {
            path: ":workspaceUuid/cdn/:cdnUuid",
            element: <CdnEditionPage />
          },
          {
            path: ":workspaceUuid",
            element: <Workspace />,
            children: [
              {
                path: "/",
                element: <Navigate to="segmentation" />
              },
              {
                path: "/segmentation",
                element: <SegmentationPage />
              },
              {
                path: "/events",
                element: <AppEventLog />
              },
              {
                path: "/cdn",
                element: <CdnList />
              },
              {
                path: "/settings",
                element: <Settings />
              }
            ]
          },
          { element: <NotFound /> }
        ]
      },
      {
        element: <NotFound />
      }
    ]
  },
  {
    path: "home",
    element: <Navigate to="../switch" />
  }
]
